/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMovieMarathonTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMovieMarathon,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Watch Some Movies!",
    "Movie Marathon Awaits!",
    "Cinematic Adventure!",
  ],
  title: "Movie Marathon",
  description: "Organize a fun movie marathon.",
  longDescription:
    "Gather your friends for a cozy movie marathon! Choose a date, decide on the films to watch, and plan snacks for the night!",
  emoji: "🎬",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Movie Marathon",
          emoji: "🎬",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the movie marathon?",
          emoji: "📅",
          completeAction: {
            question: "Decide on movies to watch?",
            description: "What movies do we want to include in the marathon?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What movies should we choose?",
                emoji: "🍿",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we have during the movie marathon?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍫",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready for Movie Night!",
    outroDescription: "Your movie marathon plans are set! Enjoy the films!",
  },
};
